import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";

/**
 * Identifies if Fenix is available in the global window object
 * @returns `true` if Fenix is available, `false` otherwise
 */
export function loadedAsESV(): boolean {
  return "fenixInitializationComplete" in window;
}

/**
 * Identifies when the user is running dash web through an ESV
 * as identified by the environment context.
 * @returns `true` if is running in an ESV, `false` otherwise
 */
export function isEsvConfig() {
  return (
    EnvCtx.surface === "desktop" && EnvCtx.dashExperience === "dash_embedded"
  );
}
